import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Drawer,
  InputAdornment,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Slide,
  TextField,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import SearchIcon from "@mui/icons-material/Search";
import LanguageIcon from "@mui/icons-material/Language";
import PersonIcon from "@mui/icons-material/Person";
import AuthModal from "../modal/auth-modal/AuthModal";
import ForgotPasswordModal from "../modal/forgot-modal/ForgotModal";
import RegisterModal from "../modal/register-modal/RegisterModal";
import logo from "../logo.svg";
import closeIcon from "../assets/icons/close.svg";
import leftIcon from "../assets/icons/left.svg";
import menuIcon from "../assets/icons/menu.svg";
import searchIcon from "../assets/icons/search.svg";
import Wrapper from "./Wrapper";
import PasswordResetModal from "../modal/pass-reset-modal/PasswordResetModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router";
import { AuthContext } from "../context/AuthProvider";
import LangSelecter from "../modal/select-lang-modal/SelectLang";
import ProfileMenu from "./ProfileMenu";
import StudyingMenu from "./StudyingMenu";
import CategoryMenu from "./CategoryMenu";
import { profileService } from "../services/profile.service";
import useCategory from "../hooks/useCategory";
import { courseService } from "../services/course.service";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import FastIcon from "./FastIcon";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const lang = [
  {
    title: "Русский",
    id: "ru",
  },
  {
    title: "Қазақ",
    id: "kz",
  },
  {
    title: "English",
    id: "en",
  },
];

const MenuBlock = styled.div`
  text-align: left;
  width: 100%;
  border-bottom: 1px solid #bfc3c8;
  padding-bottom: 8px;
  margin-bottom: 8px;
`;

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isTeacherPanel, setIsTeacherPanel] = useState(false);
  const { authenticated, setAuthenticated } = useContext(AuthContext);
  const { categories, setCategories } = useCategory();
  const [menu, setMenu] = useState<any>(null);
  const [categoryMenu, setCategoryMenu] = useState<any>(null);
  const [studying, setStudying] = useState<any>(null);
  const [queryParams] = useSearchParams();
  const [search, setSearch] = useState<any>(queryParams.get("searchValue"));
  const [profileInfo, setProfileInfo] = useState<any>(null);
  const location = useLocation();
  const closeMenu = () => {
    setMenu(null);
  };
  const closeCategoryMenu = () => {
    setCategoryMenu(null);
  };
  const closeStudying = () => {
    setStudying(null);
  };
  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenu(event.currentTarget);
  };
  const openCategoryMenu = (event: React.MouseEvent<HTMLElement>) => {
    setCategoryMenu(event.currentTarget);
  };
  const openStudying = (event: React.MouseEvent<HTMLElement>) => {
    setStudying(event.currentTarget);
  };

  const [isOpenAuth, setIsOpenAuth] = useState(
    queryParams.get("auth") === "true"
  );
  const [isOpenRegister, setIsOpenRegister] = useState(false);
  const [isOpenPassReset, setIsOpenPassReset] = useState(false);
  const [isOpenNewPass, setIsOpenNewPass] = useState(false);
  const [isOpenLangSelecter, setIsLangSelecter] = useState(false);
  const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false);
  const [isOpenMobileSearch, setIsOpenMobileSearch] = useState(false);
  const [isOpenMobileProfile, setIsOpenMobileProfile] = useState(false);

  const searchValue = queryParams.get("searchValue");

  const fetchCategory = useCallback(() => {
    courseService
      .getCourseCategories()
      .then((data) => {
        setCategories(data.data);
      })
      .catch((e) => console.log(e));
  }, [setCategories]);

  useEffect(() => {
    fetchCategory();
  }, [authenticated, fetchCategory]);

  useEffect(() => {
    setSearch(decodeURI(searchValue || ""));
  }, [searchValue]);

  /*useEffect(() => {
        setIsOpenAuth(queryParams.get('auth') === 'true' || false);
    }, [queryParams.get('auth')]);*/

  useEffect(() => {
    setIsTeacherPanel(location.pathname === "/panel");
  }, [location.pathname]);

  useEffect(() => {
    if (authenticated) {
      profileService.getProfile().then((response) => {
        setProfileInfo(response.data);
      });
    }
  }, [authenticated]);

  const togglePanel = () => {
    if (isTeacherPanel) {
      navigate("/");
    } else {
      navigate("/panel");
    }
  };

  const goToPassReset = () => {
    setIsOpenAuth(false);
    setIsOpenRegister(false);
    setIsOpenPassReset(true);
  };
  const goToRegister = () => {
    setIsOpenAuth(false);
    setIsOpenRegister(true);
    setIsOpenPassReset(false);
  };
  const goToAuth = () => {
    setIsOpenAuth(true);
    setIsOpenRegister(false);
    setIsOpenPassReset(false);
  };
  const handleCloseAuth = () => {
    setIsOpenAuth(false);
  };
  const handleCloseRegister = () => {
    setIsOpenRegister(false);
  };
  const handleClosePassReset = () => {
    setIsOpenPassReset(false);
  };
  const handleCloseNewPass = () => {
    setIsOpenNewPass(false);
  };

  const handleChangeSearch = (e: any) => {
    if (e.key === "Enter") {
      navigate(`/search?searchValue=${search}`);
      setIsOpenMobileSearch(false);
    }
  };

  const closeMobileModals = () => {
    setIsOpenMobileMenu(false);
    setIsOpenMobileSearch(false);
    setIsOpenMobileProfile(false);
  };

  const exit = () => {
    closeMobileModals();
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    setAuthenticated(false);
    navigate("/");
  };

  const onAuth = () => {
    closeMobileModals();
    setIsOpenAuth(true);
  };

  return (
    <div>
      <header className="header">
        <Wrapper>
          <img
            src={logo}
            className="logo"
            alt="logo"
            onClick={() => {
              navigate("/");
            }}
          />

          <>
            <Button
              variant="outlined"
              onClick={openCategoryMenu}
              className="header-controls">
              Категории
            </Button>
            <CategoryMenu
              anchorEl={categoryMenu}
              open={!!categoryMenu}
              handleClose={closeCategoryMenu}
            />
          </>

          <TextField
            className="header-search"
            id="header-search"
            placeholder="Ищите что угодно"
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyPress={(e) => {
              handleChangeSearch(e);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />

          {authenticated && (
            <Button
              variant="outlined"
              className="header-controls"
              onClick={togglePanel}>
              {isTeacherPanel ? "Студент" : "Панель преподавателя"}
            </Button>
          )}

          {authenticated && (
            <>
              <Button
                variant="outlined"
                className="header-controls"
                onClick={openStudying}>
                Мое обучение
              </Button>
              <StudyingMenu
                anchorEl={studying}
                open={!!studying}
                handleClose={closeStudying}
              />
            </>
          )}

          {authenticated && (
            <>
              {profileInfo?.avatar ? (
                <img
                  src={profileInfo?.avatar}
                  className="menuImg-wrp"
                  alt="menuImg-wrp"
                  onClick={openMenu}
                  onError={() =>
                    setProfileInfo({ ...profileInfo, avatar: null })
                  }
                />
              ) : (
                <Button
                  variant="outlined"
                  onClick={openMenu}
                  className="langIcon-wrapper"
                  sx={{ width: "44px", marginRight: "12px" }}>
                  {" "}
                  <PersonIcon
                    sx={{
                      color: "#A2C6E1",
                    }}
                  />
                </Button>
              )}

              <ProfileMenu
                anchorEl={menu}
                open={!!menu}
                handleClose={closeMenu}
                info={profileInfo}
                setIsLangSelecter={setIsLangSelecter}
              />
            </>
          )}

          {!authenticated && (
            <Button
              variant="contained"
              onClick={() => setIsOpenAuth(true)}
              className="header-controls">
              Войти
            </Button>
          )}

          {!authenticated && (
            <Button
              variant="outlined"
              onClick={() => setIsOpenRegister(true)}
              className="header-controls mr-0">
              Регистрация
            </Button>
          )}

          <Button
            variant="outlined"
            onClick={() => setIsLangSelecter(true)}
            className="langIcon-wrapper"
            sx={{ width: "44px" }}>
            <LanguageIcon
              sx={{
                color: "rgba(5, 115, 228, 1)",
              }}
            />
          </Button>
        </Wrapper>
      </header>

      <header className="header-mobile">
        <Wrapper>
          <img
            src={menuIcon}
            className="menu"
            alt="menu"
            onClick={() => {
              setIsOpenMobileMenu(true);
            }}
          />

          <img
            src={logo}
            className="logo"
            alt="logo"
            onClick={() => {
              navigate("/");
            }}
          />

          <img
            src={searchIcon}
            className="search"
            alt="search"
            onClick={() => {
              setIsOpenMobileSearch(true);
            }}
          />
        </Wrapper>
      </header>

      <Drawer
        anchor="left"
        open={isOpenMobileMenu}
        PaperProps={{
          sx: {
            height: "100vh",
            overflow: "auto",
          },
        }}>
        <Box
          sx={{
            width: "100%",
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
          role="presentation">
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 1,
            }}>
            <img
              src={closeIcon}
              className="closeIcon"
              alt="closeIcon"
              onClick={() => setIsOpenMobileMenu(false)}
            />
          </Box>

          <MenuBlock>
            <List>
              {authenticated && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                  onClick={() => setIsOpenMobileProfile(true)}>
                  {profileInfo?.avatar ? (
                    <img
                      src={profileInfo.avatar}
                      className="menu-avatar"
                      alt="img"
                    />
                  ) : (
                    <FastIcon name={"profileMenuIcon"} />
                  )}

                  <Box
                    sx={{
                      paddingTop: "10px",
                      paddingLeft: "12px",
                      fontWeight: 600,
                      fontSize: "14px",
                      width: "150px",
                      textWrap: "wrap",
                      wordWrap: "break-word",
                    }}>
                    <Box>
                      {profileInfo?.first_name} {profileInfo?.last_name}
                    </Box>
                  </Box>
                </Box>
              )}

              {!authenticated && (
                <ListItemButton onClick={() => onAuth()} sx={{ px: 0 }}>
                  <ListItemText
                    primary="Войти"
                    primaryTypographyProps={{
                      fontFamily: "Manrope",
                      fontWeight: 800,
                      fontSize: 14,
                      lineHeight: "140%",
                      letterSpacing: "0%",
                      color: "#0573E4",
                    }}
                  />
                </ListItemButton>
              )}

              {!authenticated && (
                <ListItemButton
                  onClick={() => setIsOpenRegister(true)}
                  sx={{ px: 0 }}>
                  <ListItemText
                    primary="Регистрация"
                    primaryTypographyProps={{
                      fontFamily: "Manrope",
                      fontWeight: 800,
                      fontSize: 14,
                      lineHeight: "140%",
                      letterSpacing: "0%",
                      color: "#0573E4",
                    }}
                  />
                </ListItemButton>
              )}
            </List>
          </MenuBlock>

          <MenuBlock>
            <ListItemButton
              onClick={() => navigate("/studying")}
              sx={{ px: 0 }}>
              <ListItemText
                primary="Мое обучение"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>
          </MenuBlock>

          <MenuBlock>
            <List>
              {categories.slice(0, 9).map((el: any) => (
                <ListItemButton
                  key={el.id}
                  onClick={() => navigate(`/search/${el.id}`)}
                  sx={{ px: 0 }}>
                  <ListItemText
                    primary={el.name}
                    primaryTypographyProps={{
                      fontFamily: "Manrope",
                      fontWeight: 800,
                      fontSize: 14,
                      lineHeight: "140%",
                      letterSpacing: "0%",
                    }}
                  />
                </ListItemButton>
              ))}
            </List>
          </MenuBlock>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
            onClick={() => setIsLangSelecter(true)}>
            <Box>
              <Box
                sx={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}>
                {t("Язык")}
              </Box>
              <Box
                className={"lang"}
                sx={{
                  fontSize: 12,
                }}>
                {
                  lang.filter((el) => localStorage.getItem("lang") === el.id)[0]
                    ?.title
                }
              </Box>
            </Box>
            <LanguageIcon />
          </Box>
        </Box>
      </Drawer>

      <Drawer
        anchor="left"
        open={isOpenMobileProfile}
        PaperProps={{
          sx: {
            width: "100vw",
            height: "100vh",
            maxWidth: "unset",
            borderRadius: 0,
            backgroundColor: "#fff",
          },
        }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 1,
            }}>
            <img
              src={closeIcon}
              className="closeIcon"
              alt="closeIcon"
              onClick={() => setIsOpenMobileProfile(false)}
            />
          </Box>

          <MenuBlock>
            <ListItemButton
              onClick={() => setIsOpenMobileProfile(false)}
              sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <img src={leftIcon} className="leftIcon" alt="leftIcon" />
              </ListItemIcon>
              <ListItemText
                primary="Меню"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>
          </MenuBlock>

          <MenuBlock>
            <ListItemButton onClick={togglePanel} sx={{ px: 0 }}>
              <ListItemText
                primary={isTeacherPanel ? "Студент" : "Панель преподавателя"}
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>

            <ListItemButton onClick={() => navigate("/profile")} sx={{ px: 0 }}>
              <ListItemText
                primary="Профиль"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>

            <ListItemButton onClick={() => navigate("/profile")} sx={{ px: 0 }}>
              <ListItemText
                primary="Личные данные"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>

            <ListItemButton onClick={() => navigate("/profile")} sx={{ px: 0 }}>
              <ListItemText
                primary="Безопасность"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>

            <ListItemButton onClick={() => navigate("/profile")} sx={{ px: 0 }}>
              <ListItemText
                primary="Мои сертификаты"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>
          </MenuBlock>

          <List>
            <ListItemButton
              onClick={() => setIsOpenMobileProfile(false)}
              sx={{ px: 0 }}>
              <ListItemText
                primary="Помощь"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>

            <ListItemButton onClick={exit} sx={{ px: 0 }}>
              <ListItemText
                primary="Выйти"
                primaryTypographyProps={{
                  fontFamily: "Manrope",
                  fontWeight: 800,
                  fontSize: 14,
                  lineHeight: "140%",
                  letterSpacing: "0%",
                }}
              />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>

      <Drawer
        anchor="right"
        open={isOpenMobileSearch}
        PaperProps={{
          sx: {
            width: "100vw",
            height: "100vh",
            maxWidth: "unset",
            borderRadius: 0,
            backgroundColor: "#fff",
          },
        }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 1,
            }}>
            <img
              src={closeIcon}
              className="closeIcon"
              alt="closeIcon"
              onClick={() => setIsOpenMobileSearch(false)}
            />
          </Box>

          <TextField
            className="header-search"
            id="header-search"
            placeholder="Ищите что угодно"
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyPress={(e) => {
              handleChangeSearch(e);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />
        </Box>
      </Drawer>

      <Dialog
        open={isOpenAuth}
        onClose={handleCloseAuth}
        TransitionComponent={Transition}
        scroll="body">
        <AuthModal
          openRegister={goToRegister}
          close={handleCloseAuth}
          openPassReset={goToPassReset}
        />
      </Dialog>

      <Dialog
        open={isOpenRegister}
        onClose={handleCloseRegister}
        TransitionComponent={Transition}
        scroll="body">
        <RegisterModal openAuth={goToAuth} close={handleCloseRegister} />
      </Dialog>

      <Dialog
        open={isOpenPassReset}
        onClose={handleClosePassReset}
        TransitionComponent={Transition}
        scroll="body">
        <ForgotPasswordModal
          close={handleClosePassReset}
          openRegister={goToRegister}
          openAuth={goToAuth}
        />
      </Dialog>

      <Dialog
        open={isOpenNewPass}
        onClose={handleCloseNewPass}
        TransitionComponent={Transition}
        scroll="body"
        disableEscapeKeyDown={true}>
        <PasswordResetModal />
      </Dialog>

      <Dialog open={isOpenLangSelecter}>
        <LangSelecter setIsLangSelecter={setIsLangSelecter} />
      </Dialog>
    </div>
  );
};

export default Header;
